const menus = [
  {
    title: 'Dashboard',
    items: [
      { label: 'Dashboard', route: '/' },
      { label: 'Dashboard Detail', route: '/dashboard-detail', description: 'Grafik jumlah merchant dan aggregator perbulan.' },
      { label: 'Dashboard Profiling', route: '/dashboard-profiling', description: 'Jumlah transaksi dan total nominal.' }
    ]
  },
  {
    title: 'Client List',
    items: [
      { label: 'Merchant List', route: '/client/merchant', description: 'Daftar merchant dari berbagai sumber onboarding.' },
      { label: 'Aggregator List', route: '/client/aggregator', description: 'Daftar merchant dari berbagai sumber onboarding.' },
      { label: 'Sub Merchant List', route: '/client/sub-merchant', description: 'Daftar sub merchant beserta aggregatornya.' }
    ]
  },
  {
    title: 'Inputer List',
    items: [
      { label: 'Inputer Merchant List', route: '/inputer/merchant', description: 'Registrasi merchant baru secara satuan maupun bulk upload.' },
      { label: 'Inputer Aggregator List', route: '/inputer/aggregator', description: 'Registrasi Aggregator baru secara satuan maupun bulk upload.' },
      { label: 'Inputer Sub Merchant List', route: '/inputer/sub-merchant', description: 'Daftar sub merchant dari tiap aggregator.' }
    ]
  },
  {
    title: 'Request List',
    items: [
      { label: 'Daftar Tugas Inputer', route: '/daftar-tugas/inputer-list', description: 'Daftar pengajuan yang diperlukan revisi data.' },
      { label: 'History Tugas Inputer', route: '/daftar-tugas/inputer-history-list', description: 'Daftar pengajuan yang pernah dilakukan oleh Inputer.' },
      { label: 'Daftar Tugas Approver 1', route: '/daftar-tugas/approver-1-list', description: 'Approval pengajuan yang dilakukan oleh Inputer.' },
      { label: 'History Tugas Approver 1', route: '/daftar-tugas/approver-1-history-list', description: 'Daftar approval yang sudah dilakukan oleh approver 1.' },
      { label: 'Daftar Tugas Approver 2', route: '/daftar-tugas/approver-2-list', description: 'Approval pengajuan yang sudah di setujui oleh approver 1.' },
      { label: 'History Tugas Approver 2', route: '/daftar-tugas/approver-2-history-list', description: 'Daftar approval yang sudah dilakukan oleh approver 1.' }
    ]
  },
  {
    title: 'Reconciliation',
    items: [
      { label: 'Regenerate Settlement', route: '/reconciliation/regenerate-settlement', description: 'Settlement ulang.' }
    ]
  },
  {
    title: 'Setting Fee',
    items: [
      { label: 'MCC & MDR', route: '/setting-fee/mccmdr', description: 'Pengaturan Merchant Discount Rate berdasarkan kategori merchant.' },
      { label: 'Setting Fee SPE', route: '/setting-fee/setting-spe-fee', description: 'Pengaturan fee sharing berdasarkan volume transaksi perbulan.' },
      { label: 'Change Log Fee SPE', route: '/setting-fee/change-log-spe-fee', description: 'Riwayat perubahan setting fee.' }
    ]
  },
  {
    title: 'Monitoring Merchant',
    items: [
      { label: 'Monitoring Merchant', route: '/monitoring-merchant', description: 'Volume transaksi masing-masing merchant per hari.' }
    ]
  },
  {
    title: 'Resend Email',
    items: [
      { label: 'Resend Email', route: '/resend-email', description: 'Kirim ulang ke email merchant.' }
    ]
  },
  {
    title: 'Internal Refund',
    items: [
      { label: 'Internal Refund', route: '/refund-internal', description: 'Refund transaksi (status).' }
    ]
  },
  {
    title: 'Settlement Setting',
    items: [
      { label: 'Settlement Setting', route: '/settlement-setting', description: 'Pengaturan settlement transaksi merchant.' }
    ]
  },
  {
    title: 'Insert Transaction Off Us',
    items: [
      { label: 'Insert Transaction Off Us', route: '/insert-transaction', description: 'Unggah data transaksi secara manual.' }
    ]
  },
  {
    title: 'Change PIC',
    items: [
      { label: 'Change PIC', route: '/change-pic', description: 'Ubah daftar tugas approval.' }
    ]
  },
  {
    title: 'Broadcast Management',
    items: [
      { label: 'Broadcast List', route: '/broadcast/broadcast', description: 'Kirim pesan ke email merchant.' },
      { label: 'Broadcast History', route: '/broadcast/broadcast-history', description: 'Daftar pesan yang pernah dikirim ke merchant.' },
      { label: 'Broadcast Log', route: '/broadcast/broadcast-log', description: 'Riwayat status pengiriman pesan ke merchant.' }
    ]
  },
  {
    title: 'Report',
    items: [
      { label: 'Merchant Transaction', route: '/report/merchant-transaction', description: 'Laporan menyeluruh transaksi terkait aktivitas pembayaran dan refund dari keseluruhan merchant.' },
      { label: 'Aggregator Transaction', route: '/report/aggregator-transaction', description: 'Laporan menyeluruh transaksi terkait aktivitas pembayaran dan refund dari keseluruhan submerchant.' },
      { label: 'Report Settlement', route: '/report-settlement', description: 'Pengaturan pengiriman laporan settlement ke merchant.' },
      { label: 'Report EDC', route: '/report-edc', description: 'Laporan seluruh transaksi QRIS, debit, credit, tapcash yang menggunakan EDC.' },
      { label: 'Report Fee Management', route: '/fee-management', description: 'Unduh laporan fee bulanan.' },
      { label: 'Report Transaksi BPJSTK', route: '/report-bpjstk', description: 'Laporan transaksi QRiS BPJS Ketenagakerjaan.' },
      { label: 'Report Transaksi CPM', route: '/report-cpm', description: 'Informasi dari transaksi QRIS Customer Presented Mode.' },
      { label: 'Report Transaksi NFC', route: '/report/nfc-transaction', description: 'Informasi dari transaksi QRIS NFC.' }
    ]
  },
  {
    title: 'Inputer Report',
    items: [
      { label: 'Inputer Merchant Transaction', route: '/report/inputer-merchant-transaction', description: 'Laporan terkait aktivitas transaksi pembayaran dan refund dari merchant yang didaftarkan oleh inputer.' },
      { label: 'Inputer Aggregator Transaction', route: '/report/inputer-merchant-transaction', description: 'Laporan terkait aktivitas transaksi pembayaran dan refund dari aggregator yang didaftarkan oleh inputer.' }
    ]
  },
  {
    title: 'Pengajuan Merchant',
    items: [
      { label: 'List Tracking Pengajuan', route: '/tracking-pengajuan/list', description: 'Monitoring proses onboarding merchant.' },
      { label: 'List Inputer Tracking Pengajuan', route: '/inputer-tracking-pengajuan/list', description: 'Daftar merchant yang sudah aktivasi.' },
      { label: 'Approval Force Active Merchant', route: '/approval-force-active-merchant', description: 'Approval pengajuan merchant secara manual.' },
      { label: 'Request Force Active Merchant', route: '/force-active-merchant', description: 'Pengajuan approval merchant secara manual.' }
    ]
  },
  {
    title: 'User Management',
    items: [
      { label: 'List User', route: '/user', description: 'Pengaturan akun portal admin.' },
      { label: 'User Role', route: '/rbac-role', description: 'Pengaturan kontrol akses.' },
      { label: 'Mapping Wilayah', route: '/rbac-mapping-wilayah', description: 'Pemetaan kode wilayah.' },
      { label: 'Mapping Cabang', route: '/rbac-mapping-cabang', description: 'Pemetaan kode cabang.' }
    ]
  },
  {
    title: 'User Management Merchant',
    items: [
      { label: 'User Merchant Management', route: '/merchant-management', description: 'Kelola perubahan email merchant dan aggregator, baik dalam kondisi sudah active dan belum active.' },
      { label: 'Mobile Merchant', route: '/user-management-merchant/mobile', description: 'Daftar pengguna aplikasi mobile merchant.' },
      { label: 'Portal Merchant', route: '/user-management-merchant/portal', description: 'Daftar pengguna aplikasi portal merchant.' }
    ]
  },
  {
    title: 'Merchant Tools',
    items: [
      { label: 'Bulk Generate QR Statis', route: '/merchant-tools/bulk-generate-qr-statis', description: 'Upload data QR untuk pembuatan stiker pembayaran.' },
      { label: 'Outlet Management', route: '/merchant-tools/outlet-management', description: 'Tools untuk merubah Outlet menjadi Merchant Utama atau melakukan pindah Outlet ke Merchant lain.' },
      { label: 'Mapping QrisTap', route: '/merchant-tools/mapping-qristap', description: 'Tools untuk merubah merchant QR EDC menjadi allowed untuk menjadi QRISTAP dengan credential mengikuti channel provider' }
    ]
  },
  {
    title: 'Management Merchant API',
    items: [
      { label: 'Management Merchant API', route: '/management-merchant-api', description: 'Konfigurasi untuk mengubah tipe client merchant SNAP / NON SNAP' }
    ]
  },
  {
    title: 'System Log',
    items: [
      {
        title: 'Audit Trail',
        items: [
          { label: 'Audit Trail Portal Admin', route: '/system-log/audit-trail/audit-trail-portal-admin', description: 'Daftar riwayat aktivitas yang terjadi di dalam sistem portal Admin BNI QRIS' },
          { label: 'Audit Trail Portal Merchant', route: '/system-log/audit-trail/audit-trail-portal-merchant', description: 'Daftar riwayat aktivitas yang terjadi di dalam sistem portal Merchant BNI QRIS' }
        ]
      },
      {
        title: 'Service Log',
        items: [
          { label: 'Bank As Client Log', route: '/system-log/service-log/bank-as-client-log', description: 'Daftar log aktivitas bank (BNI) sebagai client ketika melakukan request ke dalam service BNI QRIS' },
          { label: 'Merchant API Log', route: '/system-log/service-log/merchant-api-log', description: 'Daftar log aktivitas merchant ketika melakukan request ke dalam service API merchant BNI QRIS' },
          { label: 'Internal Service Log', route: '/system-log/service-log/internal-service-log', description: 'Daftar log aktivitas interaksi antara service-service yang ada di BNI QRIS' },
          { label: 'Inquiry Merchant Log', route: '/system-log/service-log/inquiry-merchant-log', description: 'Daftar log aktivitas BNI QRIS ketika melakukan pengecekan data ke sistem Merchant' },
          { label: 'Bank As Server Log', route: '/system-log/service-log/bank-as-server-log', description: 'Daftar log aktivtias BNI QRIS sebagai client ketika melakukan request ke dalam service Bank (BNI)' },
          { label: 'Callback Api Log ', route: '/system-log/service-log/callback-api-log', description: 'Daftar log aktivitas BNI QRIS ketika melakukan pengiriman callback (outbond) transaksi ke sistem Merchant' },
          { label: 'Mobile API Log ', route: '/system-log/service-log/mobile-api-log', description: 'Daftar log aktivitas mobile API BNI Qris  ketika terdapat aktivitas di mobile App BNI QRIS' },
        ]
      }
    ]
  },
  {
    title: 'Master Data',
    items: [
      { label: 'Management NNS', route: '/master-data/nns-management', description: 'Referensi kode serial Badan Standar Nasional.' },
      { label: 'CMER', route: '/master-data/master-cmer', description: 'Konfigurasi master data merchant kategory segment.' },
      { label: 'Branch Code (BC/KO)', route: '/master-data/master-branch-code', description: 'Konfigurasi master data branch code ( kode cabang).' },
      { label: 'Channel Provider', route: '/master-data/channel-provider', description: 'Konfigurasi master data channel provider (Vendor EDC)' },
      { label: 'Kategori Penutupan Merchant', route: '/master-data/kategori-penutupan-merchant', description: 'Konfigurasi master data kategori penutupan merchant ( close merchant)' },
    ]
  },
];

export default menus;
